<template>
    <v-row>
      <v-col>
                <div class="headline">Statistiken</div>
                <v-card>
                    <v-card-title>
                        <v-date-picker
                                v-model="pickerDate"
                                :landscape="true"
                                :full-width="true"
                                type="month"
                                locale="de-de"
                        ></v-date-picker>
                    </v-card-title>
                    <v-data-table
                            :headers="header"
                            :items="stats"
                            class="mb-4"
                            no-data-text="Keine Statistiken vorhanden"
                            :items-per-page="60"
                    >
                      <template v-slot:item.1="{ item }">
                        {{ item.devices[1] }}
                      </template>
                      <template v-slot:item.2="{ item }">
                        {{ item.devices[2] }}
                      </template>
                      <template v-slot:item.3="{ item }">
                        {{ item.devices[3] }}
                      </template>
                      <template v-slot:item.4="{ item }">
                        {{ item.devices[4] }}
                      </template>
                      <template v-slot:item.5="{ item }">
                        {{ item.devices[5] }}
                      </template>
                      <template v-slot:item.6="{ item }">
                        {{ item.devices[6] }}
                      </template>
                      <template v-slot:item.7="{ item }">
                        {{ item.devices[7] }}
                      </template>
                      <template v-slot:item.8="{ item }">
                        {{ item.devices[8] }}
                      </template>
                      <template v-slot:item.9="{ item }">
                        {{ item.devices[9] }}
                      </template>
                      <template v-slot:item.10="{ item }">
                        {{ item.devices[10] }}
                      </template>
                      <template v-slot:item.11="{ item }">
                        {{ item.devices[11] }}
                      </template>
                      <template v-slot:item.12="{ item }">
                        {{ item.devices[12] }}
                      </template>
                      <template v-slot:item.13="{ item }">
                        {{ item.devices[13] }}
                      </template>
                      <template v-slot:item.14="{ item }">
                        {{ item.devices[14] }}
                      </template>
                      <template v-slot:item.15="{ item }">
                        {{ item.devices[15] }}
                      </template>
                      <template v-slot:item.16="{ item }">
                        {{ item.devices[16] }}
                      </template>
                    </v-data-table>
                  <v-card-actions>
                    <download-csv
                      class = "v-btn theme--light v-size--default primary"
                      :data = "json_data"
                      :labels = "headerCsv"
                      name = "RU Tourenplanung Export.csv">
                      CSV Export
                    </download-csv>
                  </v-card-actions>
                </v-card>
      </v-col>
    </v-row>
</template>

<script>
import statsService from '../service/statsService'

export default {
  name: 'Stats',

  computed: {
    devices () {
      return this.$store.state.devices.all
    },
    header () {
      return [
        {text: 'Datum', value: 'date', sortable: false},
        {text: 'Kennung', value: 'identifier', sortable: false},
        {text: 'DA', value: '1', sortable: false},
        {text: 'EH', value: '2', sortable: false},
        {text: 'GS', value: '3', sortable: false},
        {text: 'KH', value: '4', sortable: false},
        {text: 'ÖO', value: '5', sortable: false},
        {text: 'ÖR', value: '6', sortable: false},
        {text: 'WS', value: '7', sortable: false},
        {text: 'WT', value: '8', sortable: false},
        {text: 'WM', value: '9', sortable: false},
        {text: 'KG', value: '10', sortable: false},
        {text: 'MW', value: '11', sortable: false},
        {text: 'TV', value: '12', sortable: false},
        {text: 'M', value: '13', sortable: false},
        {text: 'BM', value: '14', sortable: false},
        {text: 'GH', value: '15', sortable: false},
        {text: 'SK', value: '16', sortable: false}
      ]
    },
    headerCsv () {
      let deviceFields = {}
      for (const item of this.header) {
        deviceFields[item.value] = item.text
      }
      deviceFields['ww'] = 'Weiße Ware'
      deviceFields['bw'] = 'Braune Ware'
      return deviceFields
    },
    json_data () {
      let devices = []
      if (this.stats.length > 0) {
        for (const row of this.stats) {
          let deviceFields = {}
          for (const id of this.deviceIds) {
            deviceFields[id] = row.devices[id]
          }
          devices.push(Object.assign(deviceFields, {
            'date': row.date,
            'identifier': row.identifier,
            'ww': this.calcDevices(row.devices, this.deviceIdsWhite),
            'bw': this.calcDevices(row.devices, this.deviceIdsBrown)
          }))
        }
      }
      return devices
    }
  },
  methods: {
    loadStats (year, month) {
      statsService.getStatsForYearAndMonth(year, month).then(data => {
        this.stats = data
      })
    },
    calcDevices (devices, ids) {
      let amount = 0
      for (const device of ids) {
        if (devices[device] !== undefined) {
          amount += parseInt(devices[device])
        }
      }
      return amount
    },
    calcBigDevices (devices) {
      const deviceIds = [1, 2, 3, 4, 5, 7, 8, 9, 11, 15]
      let amount = 0
      for (const device in deviceIds) {
        if (devices[deviceIds[device]] !== undefined) {
          amount += parseInt(devices[deviceIds[device]])
        }
      }
      return amount
    },
    calcDevicesCooling (devices) {
      const deviceIds = [6, 10]
      let amount = 0
      for (const device in deviceIds) {
        if (devices[deviceIds[device]] !== undefined) {
          amount += parseInt(devices[deviceIds[device]])
        }
      }
      return amount
    },
    calcTvDevices (devices) {
      const deviceIds = [12, 13]
      let amount = 0
      for (const device in deviceIds) {
        if (devices[deviceIds[device]] !== undefined) {
          amount += parseInt(devices[deviceIds[device]])
        }
      }
      return amount
    }
  },
  data: () => {
    return ({
      stats: [],
      pickerDate: null,
      deviceIds: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
      deviceIdsWhite: [1, 2, 3, 4, 5, 6, 7, 8, 14],
      deviceIdsBrown: [11, 12, 13]
    })
  },
  created () {
    let date = new Date()
    this.loadStats(date.getFullYear(), date.getMonth() + 1)
  },
  watch: {
    pickerDate (val) {
      const date = val.split('-')
      this.loadStats(date[0], date[1])
    }
  }
}
</script>

<style scoped lang="scss">
    .device {
        max-width: 100px;
        overflow: hidden;
        word-wrap: break-word;
    }
</style>



// WEBPACK FOOTER //
// src/components/Stats.vue